import type { AuthProviderProps } from "react-oidc-context";

// Build-time substitution via Vite env. See .env.development for dev defaults
// and .env.example for the prod-shape contract. No runtime config fetch —
// keeps the SPA shell offline-bootable through the service worker.
//
// Lazy getter so that flipping `VITE_DEV_AUTH=true` doesn't require the OIDC
// env vars to also be set. The DevBypass code path never reads authConfig.
function buildAuthConfig(): AuthProviderProps {
  const authority = import.meta.env.VITE_OIDC_AUTHORITY;
  const clientId = import.meta.env.VITE_OIDC_CLIENT_ID;
  const audience = import.meta.env.VITE_OIDC_AUDIENCE ?? "javeed-api";

  if (!authority || !clientId) {
    throw new Error(
      "Missing OIDC config. Set VITE_OIDC_AUTHORITY and VITE_OIDC_CLIENT_ID in .env.development, " +
        "or enable VITE_DEV_AUTH=true to bypass Keycloak.",
    );
  }

  return {
    authority,
    client_id: clientId,
    redirect_uri: `${window.location.origin}/`,
    // After signout, land on /login (the explicit-entry / error-retry surface)
    // instead of /, since / auto-redirects unauthed users back to Keycloak —
    // signing out would otherwise immediately re-trigger the sign-in flow.
    post_logout_redirect_uri: `${window.location.origin}/login`,
    response_type: "code",
    scope: "openid profile email",
    extraQueryParams: { audience },
    automaticSilentRenew: true,
    loadUserInfo: true,
  };
}

let cached: AuthProviderProps | undefined;
export function getAuthConfig(): AuthProviderProps {
  return (cached ??= buildAuthConfig());
}
